import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../../../newApis/dotNetApiMethods";
import { IResponse } from "../../../../../interfaces/response";

export interface IAggregatorUser {
  userId: string;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isActive: boolean;
  roles: string[];
}

type TQuery = {
  aggregatorId: number;
};

const getAggregatorUsers = async ({
  aggregatorId,
}: TQuery): Promise<IResponse<IAggregatorUser[]>> => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.AGGREGATOR_USERS}?aggregator_id=${aggregatorId}`,
  );
  return data;
};

export default function useGetAggregatorUsers({ aggregatorId }: TQuery) {
  return useQuery(
    [{ aggregatorId }, "getAggregatorUsers"],
    () => getAggregatorUsers({ aggregatorId }),
    {
      refetchOnWindowFocus: false,
      enabled: !!aggregatorId,
    },
  );
}
